import React from 'react';
import './Title.scss';
import './Title-media.scss';
import { Props } from './interfaces';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';

const Title = ({ title, text, center, gradient, marginBottom = 0, h1, widthWindow }: Props) => {
  const mb: string =
    widthWindow > 720 && widthWindow < 1439 ? `${marginBottom / 14.4}vw` : `${marginBottom}px`;

  const tagTitle = h1 ? (
    <h1
      className={`title${gradient ? ' title_gradient' : ''}`}
      style={{
        textAlign: center ? 'center' : 'start',
        marginBottom: mb || '0',
        marginLeft: center ? 'auto' : 0,
      }}
      dangerouslySetInnerHTML={{ __html: title }}
    ></h1>
  ) : (
    <h2
      className={`title${gradient ? ' title_gradient' : ''}`}
      style={{
        textAlign: center ? 'center' : 'start',
        marginBottom: mb || '0',
        marginLeft: center ? 'auto' : 0,
      }}
      dangerouslySetInnerHTML={{ __html: title }}
    ></h2>
  );

  return (
    <>
      {tagTitle}
      {text ? (
        <p
          className="body1 title__text"
          style={center ? { textAlign: 'center' } : { textAlign: 'start', marginLeft: 0, width: 'auto' }}
        >
          {text}
        </p>
      ) : null}
    </>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(Title));
